export default "__VITE_ASSET__C28a6d6v__"